import styles from './HelpCard.module.scss';
import { VdsLink } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '@customer/store/hooks';
import { closeSidePanel } from '@customer/store/slices/globalSlice';
import { useCallback } from 'react';
import { Permission } from '@customer/permissions';

interface LinkData {
  url: string;
  value: string;
  isExternal?: boolean;
}

export interface HelpCardData {
  title: string;
  description: string | null;
  links: LinkData[];
  permission: Permission;
}

export const HelpCard = ({ title, description, links }: HelpCardData) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const onClickClose = useCallback(() => {
    dispatch(closeSidePanel());
  }, [dispatch]);

  return (
    <section className={styles.card}>
      <header className={styles.card__title}>{t(title)}</header>
      {description && <div className={styles.card__description}>{t(description)}</div>}
      <footer className={styles.card__footer}>
        {links.map(({ url, value, isExternal = false }: LinkData, i) => {
          return isExternal ? (
            <VdsLink
              key={value}
              url={url}
              value={t(value)}
              size="medium"
              target="_blank"
              rel="noopener noreferrer"
              informativeIcon="open-icon"
              iconPosition="right"
            />
          ) : (
            <Link key={value} to={url} style={{ textDecoration: 'none' }} onClick={onClickClose}>
              {/* The following VdsLink is for display only. All routing and logic performed by parent Link. */}
              <VdsLink value={t(value)} size="medium" />
            </Link>
          );
        })}
      </footer>
    </section>
  );
};

export default HelpCard;
